import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
}

export interface ComponentStyles {
    componentWrapper?: InjectableCss;
}

type Props = OwnProps;

const PaginationScrollTop: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <StyledWrapper id="PaginationScrollTop"/> 
    );
};

const definition: WidgetDefinition = {
    group: "Common",
};

const widgetModule: WidgetModule = {
    component: PaginationScrollTop,
    definition,
};

export default widgetModule;
